import { NgModule } from '@angular/core';
import { AngularFontAwesomeModule } from 'angular-font-awesome';
import { CarouselModule } from 'ngx-bootstrap/carousel';
import { SharedModule } from '../../shared/modules/shared.module';
import { ProductsListComponent } from '../products/products-list/products-list.component';
import { ProductsRoutingModule } from './products.routing';
import { SlickCarouselModule } from 'ngx-slick-carousel';
import { ProductsLineIncrementComponent } from '../products/products-line-increment/products-line-increment.component';
import { ProductsCambioProdComponent } from './products-cambio-prod/products-cambio-prod.component';

@NgModule({
  declarations: [
    ProductsListComponent,
    ProductsLineIncrementComponent,
    ProductsCambioProdComponent
  ],
  imports: [
    SharedModule,
    AngularFontAwesomeModule,
    ProductsRoutingModule,
    CarouselModule.forRoot(),
    SlickCarouselModule
  ],

  providers: [

  ],
})

export class ProductsModule {

}
